import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const apiUrl = `${baseApiUrl}/api/EmployeeContractHistory`;

export async function getEmployeeContractHistory(employeeId) {
    return await httpRequest(fetchEmployeeContractHistory.bind(this, employeeId));
}

async function fetchEmployeeContractHistory(employeeId) {
    let config = getHttpHeaders();
    return await axios.get(`${apiUrl}?employeeId=${employeeId}`, config);
}
